export default __webpack_public_path__ + "static/media/image_recruteur_3.dd0a1e23.svg";